import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=58a53dd0&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=ts&"
export * from "./ColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=58a53dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a53dd0",
  null
  
)

export default component.exports